export default __webpack_public_path__ + "static/media/coty-login-logo.6b144661.jpg";